package org.moxultimate.topwithmox.components.error

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.*
import org.moxultimate.topwithmox.components.buttons.GradientButton
import org.moxultimate.topwithmox.components.texts.MoxGradientText
import org.moxultimate.topwithmox.theme.DarkTextColor
import org.moxultimate.topwithmox.theme.WhiteBG

/**
 * Reusable Error Layout Component
 */
@Composable
fun ErrorPage(
    errorCode: String = "500",
    error: String = "Something broke on our end.",
    onTryAgain: () -> Unit
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(100.vh)
            .backgroundColor(WhiteBG),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(), // Keeps paragraph text bound naturally
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            val errorCode = if (errorCode.isEmpty() || errorCode == "0") "OOPS!" else errorCode
            MoxGradientText(
                text = errorCode,
                fontSize = 120
            )


            SpanText(
                text = "SOMETHING WENT WRONG",
                modifier = Modifier
                    .fontSize(16.px)
                    .fontWeight(FontWeight.Bold)
                    .letterSpacing(0.15.cssRem)
                    .color(DarkTextColor)
            )

            SpanText(
                text = "PLEASE TRY AGAIN LATER",
                modifier = Modifier
                    .fontSize(16.px)
                    .fontWeight(FontWeight.Bold)
                    .letterSpacing(0.15.cssRem)
                    .color(DarkTextColor)
                    .margin(bottom = 1.cssRem),
            )


            SpanText(
                text = error,
                modifier = Modifier
                    .color(Color.darkgray) // Soft grey typography
                    .fontSize(12.px)
                    .lineHeight(1.5)
                    .textAlign(TextAlign.Center)
                    .margin(bottom = 3.cssRem)
            )

            GradientButton(
                text = "Try Again",
                onClick = {
                    onTryAgain()
                }
            )
        }
    }
}

// --- REUSABLE GRADIENT MODIFIER ---
fun Modifier.errorGradientText(): Modifier = this.styleModifier {
    backgroundImage("linear-gradient(135deg, #d94065 10%, #9047a3 50%, #468bcb 90%)")
    property("-webkit-background-clip", "text")
    property("background-clip", "text")
    property("-webkit-text-fill-color", "transparent")
    property("color", "transparent")
}

// --- STYLING COEFFICIENTS ---
val ErrorCodeStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.cssRem)
            .fontWeight(FontWeight.Bold)
            .lineHeight(1)
            .margin(topBottom = 0.px)
            .errorGradientText()
    }
}

val GradientLineStyle = CssStyle {
    base {
        Modifier
            .height(2.px)
            .width(4.cssRem)
            .styleModifier {
                backgroundImage("linear-gradient(to right, #d94065, #468bcb)")
            }
    }
}
